const blogPosts = [
  {
    slug: 'cardapio-digital-por-que-seu-restaurante-precisa',
    title: 'Cardápio digital: por que seu restaurante precisa de um em 2026',
    excerpt:
      'Descubra como um cardápio digital pode aumentar suas vendas, reduzir custos com impressão e melhorar a experiência dos seus clientes.',
    date: '2026-03-25',
    readTime: '5 min',
    category: 'Tendências',
    image: null,
    content: `
## A transformação digital chegou aos restaurantes

Se você ainda depende de cardápios impressos, está perdendo oportunidades. A pandemia acelerou uma tendência que veio para ficar: **clientes preferem consultar o cardápio pelo celular**. Segundo pesquisas recentes, mais de 70% dos consumidores brasileiros já usaram um cardápio digital pelo menos uma vez.

## Vantagens de um cardápio digital

### 1. Atualização em tempo real

Acabou aquele prato especial? Um ingrediente está em falta? Com o cardápio digital, você altera preços, adiciona ou remove itens **instantaneamente**, sem precisar reimprimir nada.

### 2. Redução de custos

Cardápios impressos têm custo recorrente. Cada mudança de preço, novo prato ou atualização sazonal exige uma nova impressão. Com o digital, esse custo simplesmente desaparece.

### 3. Experiência visual rica

Fotos de alta qualidade dos pratos, descrições detalhadas e até informações sobre alérgenos — tudo isso pode ser apresentado de forma organizada e atraente no cardápio digital.

### 4. Dados e insights

Saiba quais pratos são mais visualizados, quais categorias recebem mais cliques e em quais horários seus clientes acessam o cardápio. Essas informações são valiosas para otimizar seu menu.

### 5. Higiene e praticidade

Sem contato físico, sem necessidade de limpar cardápios após cada uso. Basta o cliente escanear um QR Code na mesa e pronto.

## Como implementar

Com a **WaitHere**, criar seu cardápio digital leva menos de 10 minutos:

1. Crie sua conta gratuita.
2. Adicione categorias (entradas, pratos principais, bebidas, sobremesas).
3. Cadastre seus itens com foto, descrição e preço.
4. Imprima o QR Code e coloque nas mesas.

Seu cardápio estará disponível automaticamente no site do seu restaurante em **seurestaurante.wtr.app.br**.

## Conclusão

O cardápio digital não é mais um diferencial — é uma **necessidade**. Restaurantes que adotam essa tecnologia vendem mais, gastam menos e oferecem uma experiência superior. Comece hoje mesmo com a WaitHere.
    `.trim(),
  },
  {
    slug: 'como-aumentar-vendas-delivery-restaurante',
    title: 'Como aumentar as vendas de delivery do seu restaurante',
    excerpt:
      'Estratégias práticas para impulsionar seu delivery sem depender exclusivamente de marketplaces como iFood e Rappi.',
    date: '2026-03-20',
    readTime: '7 min',
    category: 'Gestão',
    image: null,
    content: `
## O delivery é essencial — mas depender de apps tem um custo

O delivery se consolidou como uma das principais fontes de receita para restaurantes. Porém, depender exclusivamente de marketplaces como iFood e Rappi significa pagar comissões de **15% a 27%** sobre cada pedido. Para um restaurante com margem apertada, isso pode ser a diferença entre lucro e prejuízo.

## Estratégias para vender mais no delivery

### 1. Tenha seu próprio canal de pedidos

Com a WaitHere, seu restaurante tem um site próprio com sistema de pedidos integrado. Os clientes fazem pedidos diretamente, sem intermediários, e **você não paga comissão por pedido**.

### 2. Invista em presença digital

- Mantenha seu perfil do Google Meu Negócio atualizado com fotos, horários e link para pedidos.
- Use o Instagram para mostrar seus pratos e redirecionar para seu site de pedidos.
- Peça avaliações de clientes satisfeitos.

### 3. Crie promoções exclusivas no seu canal

Ofereça descontos ou combos exclusivos para quem pede pelo seu site. Isso incentiva os clientes a migrar dos marketplaces para o seu canal direto.

### 4. Capriche na embalagem

A experiência do delivery começa na embalagem. Inclua seu logo, um bilhete personalizado e um QR Code que leva ao seu site para o próximo pedido.

### 5. Ofereça múltiplas opções de entrega

Além do delivery com entregador próprio, considere:

- **Retirada no local** (take-away) — sem custo de entrega para o cliente.
- **Entrega agendada** — o cliente escolhe o horário ideal.

### 6. Fidelização

Programas simples de fidelidade fazem diferença. Um cartão digital de "compre 10, ganhe 1" pode trazer clientes de volta ao seu canal de pedidos.

## O papel da tecnologia

Uma boa plataforma de gestão, como a WaitHere, integra tudo: cardápio, pedidos, pagamento e entrega. Com tudo centralizado, você ganha eficiência e tem mais controle sobre a operação.

## Conclusão

Diversificar seus canais de venda é fundamental. Os marketplaces são importantes para visibilidade, mas ter seu próprio canal garante margens melhores e um relacionamento direto com o cliente. A WaitHere oferece tudo o que você precisa para começar — de graça.
    `.trim(),
  },
  {
    slug: 'gestao-de-mesas-digital-restaurante',
    title: 'Gestão de mesas digital: como organizar seu salão com tecnologia',
    excerpt:
      'Conheça os benefícios da gestão de mesas digital e como ela pode reduzir erros, acelerar o atendimento e melhorar a experiência no seu restaurante.',
    date: '2026-03-15',
    readTime: '6 min',
    category: 'Operações',
    image: null,
    content: `
## O caos das comandas de papel

Quem trabalha em restaurante conhece a cena: garçom anotando pedido no papel, comanda ilegível, pedido trocado, conta errada. Esse cenário, além de frustrar clientes, gera **perdas financeiras reais**.

A gestão de mesas digital resolve esses problemas com tecnologia simples e acessível.

## Como funciona a gestão de mesas digital

Com a WaitHere, seu salão funciona assim:

1. **O cliente escaneia o QR Code da mesa** e acessa o cardápio.
2. **Faz o pedido diretamente pelo celular**, sem esperar o garçom.
3. **O pedido vai direto para a cozinha** em tempo real.
4. **A comanda da mesa é atualizada automaticamente** no painel do gerente.
5. **Na hora de fechar, a conta está pronta** — sem conferências manuais.

## Benefícios para o restaurante

### Menos erros de pedido

Quando o próprio cliente digita o que quer, eliminam-se problemas de comunicação. Sem anotações confusas, sem "achei que era sem cebola".

### Atendimento mais rápido

O garçom não precisa ir até a mesa para anotar o pedido, ir até a cozinha para entregar a comanda, e voltar à mesa para confirmar. O fluxo é direto: cliente → cozinha.

### Controle financeiro total

Cada pedido é registrado digitalmente com horário, mesa e valor. Você sabe exatamente o que foi vendido, quando e onde. Isso facilita o fechamento do caixa e a análise de vendas por período.

### Experiência do cliente

Os clientes mais jovens, em particular, preferem a autonomia de fazer o pedido pelo celular. É rápido, prático e moderno.

## E os garçons?

A tecnologia não substitui garçons — ela os **libera para o que realmente importa**: atender bem, recomendar pratos, resolver problemas e garantir que a experiência do cliente seja excelente. Em vez de anotar pedidos, eles se tornam consultores de experiência.

## Implementação simples

Com a WaitHere, configurar a gestão de mesas leva minutos:

1. Defina o número de mesas no painel.
2. Gere os QR Codes individuais.
3. Imprima e posicione nas mesas.

Pronto. Seu salão está digitalizado.

## Conclusão

A gestão de mesas digital não é luxo de restaurante grande — é uma ferramenta acessível que qualquer estabelecimento pode (e deveria) adotar. Menos erros, mais velocidade e melhor controle financeiro. Experimente a WaitHere gratuitamente e transforme a operação do seu salão.
    `.trim(),
  },
  {
    slug: 'como-criar-site-restaurante-gratis',
    title: 'Como criar o site do seu restaurante grátis em 10 minutos',
    excerpt:
      'Passo a passo para criar um site profissional para seu restaurante sem precisar de designer ou programador.',
    date: '2026-03-10',
    readTime: '4 min',
    category: 'Tutorial',
    image: null,
    content: `
## Seu restaurante precisa de um site

Em 2026, a primeira coisa que um cliente faz antes de ir a um restaurante é **pesquisar no Google**. Se seu restaurante não aparece com um site profissional, você está perdendo clientes para a concorrência.

Mas criar um site não precisa ser caro nem complicado. Com a WaitHere, você cria um site completo em menos de 10 minutos — sem pagar nada.

## Passo a passo

### 1. Crie sua conta

Acesse **dash.waithere.com.br** e crie sua conta gratuita. Preencha o nome do restaurante, tipo de cozinha e endereço.

### 2. Personalize a identidade visual

No painel, vá em "Meu Site" e personalize:

- **Logo** do restaurante
- **Cores** principais (combinando com sua marca)
- **Banner** com foto do restaurante ou dos pratos
- **Fontes** e estilo visual

### 3. Adicione suas informações

Preencha as informações essenciais:

- Horário de funcionamento
- Endereço completo
- Telefone e WhatsApp
- Links do Instagram e Facebook
- Formas de pagamento aceitas

### 4. Configure o cardápio

Adicione categorias e itens com fotos, descrições e preços. O cardápio aparecerá automaticamente no site com um visual profissional.

### 5. Publique

Clique em "Publicar" e pronto! Seu site estará disponível em **seurestaurante.wtr.app.br** instantaneamente.

## O que está incluído no site gratuito

- Design responsivo (funciona em celular, tablet e computador)
- Cardápio digital integrado
- Informações de contato e localização
- QR Code para as mesas
- Certificado SSL (site seguro)

## Dicas para um site de restaurante eficaz

1. **Use fotos reais e de qualidade.** Fotos profissionais dos pratos fazem enorme diferença.
2. **Mantenha o cardápio atualizado.** Nada pior do que um cliente chegar e o prato não existir mais.
3. **Destaque seu diferencial.** É vegano? Tem opções sem glúten? Delivery grátis? Coloque isso em destaque.
4. **Inclua avaliações.** Se possível, mostre depoimentos de clientes satisfeitos.

## Conclusão

Ter um site profissional não é mais privilégio de grandes redes. Com a WaitHere, qualquer restaurante, lanchonete ou cafeteria pode ter presença digital de qualidade — sem custo e sem complicação. Crie o seu agora mesmo.
    `.trim(),
  },
]

export default blogPosts
